/* eslint-disable no-unused-vars */
import { useRef, useMemo } from 'react';
import {
  ModalBase,
  ModalHeader,
  ModalFooter,
  ToggleBtn,
  Search,
  Separators,
  Loader,
} from 'components';
import * as S from './ChooseAppsMonthlyBudgets.styled';
import { ContentHeader } from './components/contentHeader/ContentHeader';
import { Content } from './components/content/Content';
import { useFacade } from './useFacade';
// import { monthlyBudgetAPI } from 'services/monthlyBudget.service';

export const ChooseAppsMonthlyBudgets = ({ isOpen$, result, saveAction, saveResult }) => {
  const {
    userSearch$,
    changeSearchValue,
    isToggleBtnOn$,
    updateSortConfig,
    //indexErrorItems$,
    virtuosoErrorMsgRef,
    handleChangeIsEdit,
    itemsToDisplay$,
    updateCounter,
    onChangeMonthlyBudget,
    saveBtnClick,
    closeModal,
    modalWindowIsEdited$,
    getSortDirection,
    updateGeoBudgetItems,
    updateIsOpenBudget,
    updateIsAgency,
    updateIsBudgetPerGeo,
    handleDeleteSearch,
  } = useFacade(isOpen$, result, saveAction);

  const searchRef = useRef(null);
  // const allCountries = monthlyBudgetAPI.useGetCountriesQuery();
  const isLoading = useMemo(() => {
    return (
      (result.isLoading || result.isFetching || !result.data) && !result.isError // ||
      // ((allCountries.isLoading || allCountries.isFetching || !allCountries.data) && !allCountries.isError)
    );
  }, [
    result.isLoading,
    result.isFetching,
    result.data,
    result.isError,
    //allCountries.isLoading,
    //allCountries.isFetching,
    //allCountries.data,
    //allCountries.isError,
  ]);

  return (
    <ModalBase>
      <ModalHeader title='Apps Monthly Budgets' close={closeModal} />
      <S.SearchContainer>
        <Search
          ref={searchRef}
          width={459}
          placeholder='Search App'
          value={userSearch$.value}
          onChange={changeSearchValue}
          rightIconOnClick={handleDeleteSearch}
        />
        <ToggleBtn
          textStyle={{ fontSize: '12px' }}
          isReverse
          lableOn='Show only reached budget'
          labelOff='Show only reached budget'
          id='appsBudgetsToggle'
          isChecked={isToggleBtnOn$.value}
          onChange={() => {
            isToggleBtnOn$.value = !isToggleBtnOn$.value;
          }}
        />
      </S.SearchContainer>
      <Separators type={Separators.separatorTypes.small} />
      <ContentHeader updateSortConfig={updateSortConfig} getSortDirection={getSortDirection} />
      <Separators type={Separators.separatorTypes.small} />
      <Separators type={Separators.separatorTypes.small} />
      {isLoading ? (
        <S.LoaderWrapper>
          <Loader.Local delay={0} />
        </S.LoaderWrapper>
      ) : (
        <Content
          // allCountries={allCountries.data}
          // indexErrorItems$={indexErrorItems$}
          virtuosoErrorMsgRef={virtuosoErrorMsgRef}
          handleChangeIsEdit={handleChangeIsEdit}
          searchValue={userSearch$.value}
          // TO-DO handle allCountries request error
          isError={result.isError}
          itemsToDisplay$={itemsToDisplay$}
          onChangeMonthlyBudget={onChangeMonthlyBudget}
          onUpdateGeoBudgetItems={updateGeoBudgetItems}
          onUpdateIsOpenBudget={updateIsOpenBudget}
          onUpdateIsAgency={updateIsAgency}
          onUpdateIsBudgetPerGeo={updateIsBudgetPerGeo}
        />
      )}
      <ModalFooter
        saveButtonText='Save'
        saveButtonOnClick={saveBtnClick}
        close={closeModal}
        saveButtonDisabled={!modalWindowIsEdited$.value}
      />
    </ModalBase>
  );
};
